<template>
    <div id="content">
        <div class="admin-page-header">
            <div>
                <h1 class="admin-page-title">{{ $t('modules.list.title') }}</h1>
                <p class="admin-page-subtitle" v-if="modules.length">{{ modules.length }} {{ pluralizeModule(modules.length) }}</p>
            </div>
            <router-link to="/modules/new" class="btn-purple">
                <i class="bi bi-plus-lg"></i>
                <span>{{ $t('modules.list.create') }}</span>
            </router-link>
        </div>

        <div v-if="!modules.length" class="admin-empty">
            <i class="bi bi-diagram-2"></i>
            <div class="admin-empty-title">{{ $t('modules.list.emptyTitle') }}</div>
            <div>{{ $t('modules.list.emptyDescription') }}</div>
        </div>

        <div v-else class="module-list">
            <router-link
                v-for="m in modules"
                :key="m.id"
                :to="'/modules/' + m.id"
                class="admin-card admin-card-hover module-row"
            >
                <div class="module-row-icon">
                    <i class="bi bi-diagram-2"></i>
                </div>
                <div class="module-row-main">
                    <div class="module-row-name">{{ m.name }}</div>
                    <div class="module-row-desc">{{ m.description || $t('modules.list.noDescription') }}</div>
                </div>
                <div class="module-row-arrow">
                    <i class="bi bi-chevron-right"></i>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    data:() => ({
        modules: []
    }),
    async mounted() {
        this.$emit('setPageTitle', this.$t('modules.list.title'))
        this.modules = await this.getModules()
    },
    methods: {
        async getModules() {
            let r = await this.$api.getModules()
            if(r.result === 'SUCCESS') {
                return r.data
            } else {
                this.$notify({
                    text: r.msg,
                    type: r.result.toLowerCase()
                })
                return []
            }
        },
        pluralizeModule(n) {
            const mod10 = n % 10
            const mod100 = n % 100
            if (mod10 === 1 && mod100 !== 11) return this.$t('modules.list.unitOne')
            if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return this.$t('modules.list.unitFew')
            return this.$t('modules.list.unitMany')
        }
    }
}
</script>

<style scoped>
.module-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.module-row {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px 20px;
    text-decoration: none;
    color: inherit;
}

.module-row:hover {
    color: inherit;
}
.module-row:hover .module-row-arrow {
    color: #7c3aed;
    transform: translateX(2px);
}

.module-row-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: #faf7ff;
    border: 1px solid #ede9fe;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: #7c3aed;
    font-size: 20px;
}

.module-row-main {
    flex: 1;
    min-width: 0;
}

.module-row-name {
    font-size: 15px;
    font-weight: 600;
    color: #0f172a;
    margin-bottom: 2px;
}

.module-row-desc {
    font-size: 13px;
    color: #64748b;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}

.module-row-arrow {
    color: #cbd5e1;
    font-size: 18px;
    transition: color 0.15s ease, transform 0.15s ease;
    flex-shrink: 0;
}
</style>
